// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__1zMsG","section":"style_section__2I9sy","tabsTitle":"style_tabsTitle__1IhrM","tabsActive":"style_tabsActive__1ADVI","searchBox":"style_searchBox__2ZaZZ"};